/**
 * Portfolio component
 *
 * Highlights some of  your creations. These can be designs, websites,
 * open source contributions, articles you've written and more.
 *
 * This is a great area for you to to continually add to and refine
 * as you continue to learn and create.
 */

import React from "react";

/**
 * Desk image
 *
 * Below is a sample desk image. Feel free to update this to an image of your choice,
 * updating below imageAltText to string that represents what you see in that image.
 *
 * Need an image? Check out https://unsplash.com to download a photo you
 * freely use on your site.
 */
import image from "../images/desk.jpg";

const imageAltText = "desktop with books and laptop";

/**
 * Project list
 *
 * An array of objects that will be used to display for your project
 * links section. Below is a sample, update to reflect links you'd like to highlight.
 */
const projectList = [
  {
    title: "Serenity",
    description:
      "An AI chatbot that helps people with Depression, Anxiety and other mental health issues. It is a Python application that uses a chatbot to interact with the user and provide them with the necessary help.",
    url: "https://github.com/Abhayg444/Serenity",
  },
  {
    title: "Meddy",
    description:
      "An Symptom Checker and Disease Prediction System. It is a Python application that uses a chatbot to interact with the user and provide them with the necessary help.",
    url: "https://github.com/Abhayg444/Meddy",
  },
  {
    title: "To-do-list",
    description: "A React application that allows users to create a to-do list.",
    url: "https://github.com/Abhayg444/To-do-list",
  },
  {
    title: "BattleShip",
    description: "A React application that allows users to play the classic game of Battleship.",
    url: "https://github.com/Abhayg444/Battleships",
  },
];

const Portfolio = () => {
  return (
    <section className="padding" id="portfolio">
      <h2 style={{ textAlign: "center" }}>Portfolio</h2>
      <div style={{ display: "flex", flexDirection: "row", paddingTop: "3rem" }}>
        <div style={{ maxWidth: "40%", alignSelf: "center" }}>
          <img
            src={image}
            style={{ height: "90%", width: "100%", objectFit: "cover" }}
            alt={imageAltText}
          />
        </div>
        <div className="container">
          {projectList.map((project) => (
            <div className="box" key={project.title}>
              <a href={project.url} target="_blank" rel="noopener noreferrer">
                <h3 style={{ flexBasis: "40px" }}>{project.title}</h3>
              </a>
              <p className="small">{project.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
